import { createCategoryLandingDefaultFormFields } from '../common/formFields'
import { getGenericCodeTemplatePreset } from '../common/genericPresets'
import { getCategoryLandingHeroImage } from '../common/heroImages'

export function getHiddenInsuranceMoneyPreset(presetKey = 'default') {
  if (presetKey === 'lead-gen-fullbleed') {
    return getGenericCodeTemplatePreset('HIDDEN_INSURANCE_MONEY', 'lead-gen-fullbleed')
  }
  if (presetKey === 'basic-template-4' || presetKey === 'basic-template-5') {
    return getGenericCodeTemplatePreset('HIDDEN_INSURANCE_MONEY', presetKey)
  }
  if (presetKey === 'clean-form') {
    return {
      key: 'hidden-insurance-money-clean-form',
      category: 'HIDDEN_INSURANCE_MONEY',
      name: '숨은보험금찾기 기본 템플릿 2 - 간편 문의형',
      heroTitle: '미청구·미수령 보험금 가능성을 확인해보세요',
      heroSubtitle: '기억나는 가입 정보와 기본 연락처를 바탕으로 확인 범위와 다음 절차를 안내합니다.',
      heroImageFileId: getCategoryLandingHeroImage('HIDDEN_INSURANCE_MONEY'),
      formTitle: '확인 상담 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🔎', title: '확인 범위 안내', description: '미청구·미수령 가능성이 있는지 상담 범위를 정리합니다.' },
            { icon: '📄', title: '필요 정보 정리', description: '기억나는 보험사, 가입 시기, 사고·진료 이력을 확인합니다.' },
            { icon: '💬', title: '후속 절차 안내', description: '필요한 경우 청구 가능성과 준비 자료를 안내합니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields(),
      surveyCustomFields: [
        { id: 'q1', type: 'text', label: '기억나는 보험사가 있나요?', required: false, placeholder: '예: 삼성생명, 한화생명' },
      ],
      customConfig: {
        templateStyle: 'clean-form',
        heroBackgroundColor: '#eef6ff',
        heroTextColor: '#0f172a',
        heroSubtitleColor: '#2563eb',
        formBorderColor: '#2563eb',
        formBorderWidth: 3,
      },
    }
  }

  if (presetKey === 'hanwha-sections') {
    return {
      key: 'hidden-insurance-money-hanwha-sections',
      category: 'HIDDEN_INSURANCE_MONEY',
      name: '숨은보험금찾기 기본 템플릿 3 - 설명형',
      heroTitle: '잊고 있던 보험금, 지금 확인해 보세요',
      heroSubtitle: '기억나는 정보만 남겨도 미청구·미수령 가능성을 함께 살펴보고, 다음 절차를 안내해드립니다.',
      heroImageFileId: getCategoryLandingHeroImage('HIDDEN_INSURANCE_MONEY'),
      formTitle: '숨은보험금 확인 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '🔎', title: '조회 가능 범위 확인', description: '미청구·미수령 가능성을 확인할 범위를 먼저 정합니다.' },
            { icon: '📊', title: '상담 기준 정리', description: '가입 정보와 과거 청구 이력을 바탕으로 방향을 잡습니다.' },
            { icon: '📞', title: '다음 절차 안내', description: '필요한 경우 준비 자료와 청구 방향을 안내합니다.' },
          ],
        },
        {
          type: 'faq',
          title: '자주 묻는 질문',
          items: [
            { question: '숨은 보험금은 무엇인가요?', answer: '보험금 청구 요건이 있었지만 청구하지 않았거나, 만기·휴면 등으로 확인이 필요한 금액을 말합니다.' },
            { question: '처음부터 서류가 모두 필요한가요?', answer: '처음 상담은 기억나는 보험사, 가입 시기, 사고·진료 이력처럼 확인 가능한 정보부터 시작할 수 있습니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: [
        { id: 'q1', type: 'text', label: '기억나는 보험사가 있나요?', required: false, placeholder: '예: 삼성생명, 한화생명' },
        { id: 'q2', type: 'textarea', label: '추가로 알고 계신 내용이 있나요?', required: false, placeholder: '보험 종류, 가입 시기 등을 적어주세요.' },
      ],
      customConfig: {
        templateStyle: 'hanwha-sections',
        heroBackgroundColor: '#eff6ff',
        heroTextColor: '#0f172a',
        heroSubtitleColor: '#1d4ed8',
        formBorderColor: '#2563eb',
        formBorderWidth: 3,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
      },
    }
  }

  return {
    key: 'hidden-insurance-money-default',
    category: 'HIDDEN_INSURANCE_MONEY',
    name: '숨은보험금찾기 기본 템플릿 1 - 일반형',
    heroTitle: '미청구·미수령 보험금 가능성을 확인해보세요',
    heroSubtitle: '가입 내역과 과거 사고·진료 이력을 기준으로 확인 범위와 다음 절차를 안내합니다.',
    heroImageFileId: getCategoryLandingHeroImage('HIDDEN_INSURANCE_MONEY'),
    formTitle: '숨은 보험금 조회 신청',
    contentSections: [
      {
        type: 'text',
        title: '왜 확인이 필요할까요?',
        content: '보험금은 사고·진료 이력, 청구 가능 기간, 가입 담보에 따라 달라질 수 있습니다.\n기억하지 못한 계약이나 빠뜨린 청구가 있다면 상담으로 확인할 항목을 정리해 드립니다.',
      },
      {
        type: 'process-steps',
        title: '진행 방식',
        steps: [
          { number: 1, icon: '📝', title: '기본 정보 접수', description: '연락처와 기억나는 가입 정보를 남겨주세요.' },
          { number: 2, icon: '🔎', title: '확인 범위 정리', description: '가입 내역과 과거 이력을 바탕으로 가능성을 살펴봅니다.' },
          { number: 3, icon: '📞', title: '준비 자료 안내', description: '필요한 경우 청구 방향과 준비 자료를 안내합니다.' },
        ],
      },
    ],
    formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
    surveyCustomFields: [
      { id: 'q1', type: 'text', label: '기억나는 보험사가 있나요?', required: false, placeholder: '예: 삼성생명, 한화생명' },
      { id: 'q2', type: 'textarea', label: '추가로 알고 계신 내용이 있나요?', required: false, placeholder: '보험 종류, 가입 시기 등을 적어주세요.' },
    ],
    customConfig: {
      templateStyle: 'default',
      heroBackgroundColor: '#f8fafc',
      heroTextColor: '#0f172a',
      heroSubtitleColor: '#475569',
      heroScrollCtaLabel: '숨은보험금 찾아보기',
    },
  }
}
